import * as THREE from "three";
import Action from "../../classes/Action";
import {timelineElementMap} from "../../classes/timeline";
import TimelineObject from "../../classes/timeline/TimelineObject";
import store, {StoreActions} from "../../state/store";
import {ObjectGroup} from "../../classes/GroupsManager";
import {Timeline} from "../../classes/timeline/Timeline";

export default class SetTimelineObjectReferenceAction extends Action
{
	constructor(object: TimelineObject, newReference: ObjectGroup | THREE.Object3D)
	{
		const oldReference = object.getReferenced();

		super(
			[object, newReference],
			[object, oldReference],
			"Set timeline object reference to: " + newReference.name,
			[object, oldReference, newReference]
		);
	}

	do(object: TimelineObject, reference: ObjectGroup | THREE.Object3D) : void
	{
		const timelineId = store.getState().timelineModule.editorData.timelineId;
		if (!timelineId)
		{
			throw new Error("Timeline ID is undefined");
		}

		const timeline = timelineElementMap.get(timelineId) as Timeline;
		timeline.resetAnimations();
		object.setReference(reference);
		timeline.update();
		store.dispatch(StoreActions.timeline.updateEditorUI());
	}

	verify(object: TimelineObject, oldReference: ObjectGroup | THREE.Object3D, newReference: string | THREE.Object3D) : boolean
	{
		if(!object || oldReference === newReference) return false;

		for (const objectInSameTrack of object.track.objects)
		{
			if (!objectInSameTrack.hidden && objectInSameTrack.getReferenced() === newReference) return false;
		}
		
		return true;
	}
}
